module.exports = __webpack_public_path__ + "img/p01.49b17c0b.png";